module.exports = __webpack_public_path__ + "img/UTJORD-3.e087fbb8.jpg";